import { useNavigate } from "react-router";

import YearSelector from "./YearSelector/YearSelector";

import styles from "./PeriodSelector.module.css";
import { useEffect, useState } from "react";

function PeriodSelector({ ra, period, setPeriod, setIsLoading }) {
	const navigate = useNavigate();
	const [year, setYear] = useState(period.split(".")[0]);
	const [semester, setSemester] = useState(period.split(".")[1]);

	useEffect(() => {
		if (year != period.split(".")[0] || semester != period.split(".")[1]) {
			setIsLoading(true);

			setPeriod(`${year}-${semester}`);
			navigate(`/${year}-${semester}/aluno/${ra}`);
		}
	}, [year, semester]);

	return (
		<div className={styles.container}>
			<YearSelector
				year={year}
				setYear={setYear}
			/>
			<div className={styles.switch}>
				<div
					className={
						period.split(".")[1] === "1"
							? [styles.tab, styles.active].join(" ")
							: styles.tab
					}
					onClick={() => setSemester(1)}
				>
					1º Semestre
				</div>
				<div
					className={
						period.split(".")[1] === "2"
							? [styles.tab, styles.active].join(" ")
							: styles.tab
					}
					onClick={() => setSemester(2)}
				>
					2º Semestre
				</div>
			</div>
		</div>
	);
}

export default PeriodSelector;
